import { render, staticRenderFns } from "./TrialMsg.vue?vue&type=template&id=147d210a&scoped=true"
import script from "./TrialMsg.vue?vue&type=script&lang=js"
export * from "./TrialMsg.vue?vue&type=script&lang=js"
import style0 from "./TrialMsg.vue?vue&type=style&index=0&id=147d210a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d210a",
  null
  
)

export default component.exports